'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCredentials$002dUsage$002dPage$0024 from "./presto.-Credentials-Usage-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002453 from "./presto.-Presto-Router$$anon$53.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$52() {
  this.bjT = null;
  this.bjL = null;
  this.bjM = false;
  this.bjU = null;
  this.bjV = false;
  this.bjY = null;
  this.bjR = null;
  this.bjS = false;
  this.bjN = null;
  this.bjO = false;
  this.bjP = null;
  this.bjQ = false;
  this.bjW = false;
  this.bjX = false;
  this.bjT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bjY = "CredentialsUsagePage";
}
export { $c_Lpresto_PrestoRouter$$anon$52 as $c_Lpresto_PrestoRouter$$anon$52 };
$p = $c_Lpresto_PrestoRouter$$anon$52.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$52;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$52() {
}
export { $h_Lpresto_PrestoRouter$$anon$52 as $h_Lpresto_PrestoRouter$$anon$52 };
$h_Lpresto_PrestoRouter$$anon$52.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bjT;
});
$p.L = (function() {
  if ((!this.bjM)) {
    this.bjL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bjM = true;
  }
  return this.bjL;
});
$p.O = (function() {
  if ((!this.bjV)) {
    this.bjU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bjV = true;
  }
  return this.bjU;
});
$p.E = (function() {
  return this.bjY;
});
$p.t = (function() {
  if ((!this.bjS)) {
    this.bjR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bjS = true;
  }
  return this.bjR;
});
$p.M = (function() {
  if ((!this.bjO)) {
    this.bjN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bjO = true;
  }
  return this.bjN;
});
$p.Q = (function() {
  if ((!this.bjQ)) {
    this.bjP = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002453.$c_Lpresto_PrestoRouter$$anon$53();
    this.bjQ = true;
  }
  return this.bjP;
});
$p.w = (function() {
  if ((!this.bjX)) {
    this.bjW = false;
    this.bjX = true;
  }
  return this.bjW;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee398) => ((p) => \u03b4scrutinee398))($j_presto$002e$002dCredentials$002dUsage$002dPage$0024.$m_Lpresto_CredentialsUsagePage$())));
});
var $d_Lpresto_PrestoRouter$$anon$52 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$52, "presto.PrestoRouter$$anon$52", ({
  Ok: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$52 as $d_Lpresto_PrestoRouter$$anon$52 };
//# sourceMappingURL=presto.-Presto-Router$$anon$52.js.map
